import styled from "styled-components";

/* ── StatCard ── */

export const CardWrapper = styled.div`
  padding: 12px 14px;
  background: ${({ $bg }) => $bg};
  border-radius: 10px;
  border: 1px solid ${({ $accent }) => $accent}22;
  min-width: 0;
`;

export const CardLabel = styled.div`
  font-size: 9.5px;
  font-weight: 700;
  color: ${({ $accent }) => $accent};
  text-transform: uppercase;
  letter-spacing: 0.07em;
  margin-bottom: 6px;
  font-family: var(--font-sans);
`;

export const CardValue = styled.div`
  font-size: 26px;
  font-weight: 800;
  color: var(--ink);
  font-family: var(--font-mono);
  letter-spacing: -0.03em;
  line-height: 1;
`;

export const CardUnit = styled.div`
  font-size: 9.5px;
  color: var(--ink-4);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-family: var(--font-mono);
  margin-top: 4px;
`;

/* ── CompactComparisonRow ── */

export const CompactRowContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  background: ${({ $bgColor }) => $bgColor};
  border-radius: 8px;
  border: 1px solid ${({ $borderColor }) => $borderColor};
  overflow: hidden;
`;

export const CompactRowLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 10px 14px;
  min-width: 120px;
  flex-shrink: 0;
  border-right: 1px solid ${({ $borderColor }) => $borderColor};
`;

export const CompactRowIcon = styled.span`
  font-size: 14px;
`;

export const CompactRowLabelText = styled.span`
  font-size: 10px;
  font-weight: 700;
  color: ${({ $accentColor }) => $accentColor};
  text-transform: uppercase;
  letter-spacing: 0.07em;
  font-family: var(--font-sans);
`;

export const CompactFYSection = styled.div`
  flex: 1;
  padding: 8px 16px;
  ${({ $borderRight }) =>
    $borderRight && `border-right: 1px solid ${$borderRight};`}
`;

export const CompactFYHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
  align-items: baseline;
`;

export const CompactFYLabel = styled.span`
  font-size: 10px;
  color: var(--ink-3);
  font-family: var(--font-sans);
`;

export const CompactFYValue = styled.span`
  font-size: 11px;
  font-weight: 700;
  font-family: var(--font-mono);
  color: ${({ $color }) => $color};
`;

export const CompactFYUnit = styled.span`
  font-size: 9.5px;
  font-weight: 400;
  color: var(--ink-4);
`;
